import React from 'react'
import {HiOutlineArrowRight} from 'react-icons/hi';
import {BiUser} from 'react-icons/bi';
import {MdWifiCalling} from 'react-icons/md';
import {RiBuilding2Line} from 'react-icons/ri';
import {AiOutlineMail} from 'react-icons/ai'; 
import hed from '../../img/intelli X Logo.png'; 
import Age from '../../img/G370.png'; 
import "./Model.css";


const Model = () => {
  return (
   <>
   <section>
   <div> 
          <div > 
       <div style={{display:'flex', justifyContent:'end', }}>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          </button>
          </div>

          <div className='row'>  
           <div className='col-lg-6 col-sm-12 mt-2'>
           <img src={hed} alt='#' style={{width:'50%'}}/>

           <div className='ms-1 mt-2'>
            <h3 style={{color:'#343434 '}}>Get In touch  <HiOutlineArrowRight/></h3>
           </div>

                    
           <form className='form'>
           
           <div class="input-group mt-4 mt-3">
           <span class="input-group-text" id="basic-addon1"
            style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><BiUser style={{fontSize:'22px'}}/></span>
           <input type="text" class="form-control py-2" placeholder="Enter your name" aria-label="Username" aria-describedby="basic-addon1" required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
         </div>  


         <div class="input-group mt-4 mt-3">
         <span class="input-group-text" id="basic-addon1"
          style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><RiBuilding2Line style={{fontSize:'22px'}}/></span>
         <input type="text" class="form-control py-2" placeholder="Enter name of your institution" aria-label="Username" aria-describedby="basic-addon1 " required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
       </div>



         <div class="input-group mt-4 mt-3">
         <span class="input-group-text" id="basic-addon1"
          style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><MdWifiCalling style={{fontSize:'22px'}}/></span>
         <input type="number" class="form-control py-2" placeholder="Enter your contact number" aria-label="Username" aria-describedby="basic-addon1" required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
       </div>



         <div class="input-group mt-4 mt-3">
         <span class="input-group-text" id="basic-addon1"
          style={{backgroundColor:'transparent',border:'1px solid #EDEDED', borderRadius:'8px 0px 0px 8px'}}><AiOutlineMail style={{fontSize:'22px'}}/></span>
         <input type="email" class="form-control py-2" placeholder="Enter your email address" aria-label="Username" aria-describedby="basic-addon1" required style={{border:'1px solid #EDEDED', borderLeft:'none',borderRadius:'0px 8px 8px 0px',boxShadow:'none'}}/>
       </div>



       <div className='mt-5'>
        <button type='Submit' style={{backgroundColor:'#3572FA',color:'#fff', borderRadius:'8px ', padding:'10px 12px', border:'none', width:'100%'}}>Submit</button>
       </div>
         
           
           </form> 

           </div>


           <div className='col-lg-6 col-sm-12 mt-2'>
         
           <img src={Age} className='gajju' alt='#' style={{width:'100%',height:'500px'}}/>
           
           </div>
          </div>
            
          </div> 

    </div> 
  </section>
   </>
  )
}

export default Model;